export const ApiEndpoints = {
    BASE_URL: "/api",
    LIVE_MATCHES: "/statistics/matches/live",
    GET_SCHEDULED_MATCHES: "/scheduler/matches/future",
    GET_MATCH_STAT: "/statistics/matches",
    GET_MATCHES_CARD: "/statistics/matches/card",
    GET_TEAMS: "/statistics/teams",
    GET_PLAYERS: "/statistics/players",
    GET_LAST_OUTCOME: "/statistics/last/outcome",
    ADMIN_LOGIN: "/admins/login",
    GET_LATEST_ODDS: "/matchConfig/latest-odds",
};
